"use client";

export { TopNav as Nav } from "@/components/mot/chrome";
